<template>
    <div>
        <Breadcrumb section-name="Report" :breadcrumb="breadCrumb"></Breadcrumb>
        <div class="col-12">
            <div class="card mb-0">
                <div class="card-body">
                    <div class="row mb-3 g-2 align-items-end">
                        <div class="col-auto">
                            <a class="btn btn-option" href="javascript:void(0)" @click="downloadFile">
                                <img v-if="!exportLoading" class="print" width="16" height="16"/>
                                <span v-if="exportLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            </a>
                        </div>
                        <div class="col-md-3 form-group mb-0">
                            <select class="form-control" v-model="params.project_id" name="project_id">
                                <option value="">Select Project</option>
                                <option v-for="each in projects" :value="each.id" v-text="each.name"></option>
                            </select>
                        </div>
                        <div class="col-md-2 form-group mb-0">
                            <flat-pickr class="form-control" placeholder="Start Date" name="start_date"
                                v-model="params.start_date"
                                :config="{dateFormat: 'Y-m-d', altInput: true, altFormat:'d/m/Y'}"/>
                        </div>
                        <div class="col-md-2 form-group mb-0">
                            <flat-pickr class="form-control" placeholder="End Date" name="end_date"
                                v-model="params.end_date"
                                :config="{dateFormat: 'Y-m-d', altInput: true, altFormat:'d/m/Y'}"/>
                        </div>
                        <div class="col-md-2">
                            <button class="btn btn-inverse-primary w-100" @click="handleData">Search</button>
                        </div>
                    </div>
                    <div class="table-height long-scroll">
                        <table class="table mb-0 table-striped table-bordered dataTable">
                            <thead>
                            <tr>
                                <th>Sl</th>
                                <th>Date</th>
                                <th>Day</th>
                                <th>Payment Method</th>
                                <th>Deposit By</th>
                                <th>Bank Name</th>
                                <th>Check Number</th>
                                <th class="text-end">Amount</th>
                                <th>Payment Received By</th>
                                <th>Remarks</th>
                                <th>Costing Item</th>
                            </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(data,index) in reportData.data">
                                    <td>{{ index + 1 }}</td>
                                    <td>{{ data.date }}</td>
                                    <td>{{ data.day }}</td>
                                    <td>{{ data.payment_method }}</td>
                                    <td>{{ data.deposit_by }}</td>
                                    <td>{{ data.bank_name }}</td>
                                    <td>{{ data.check_number }}</td>
                                    <td class="text-end">{{ data.amount }}</td>
                                    <td>{{ data.received_by }}</td>
                                    <td>{{ data.remarks }}</td>
                                    <td>{{ data.costing_item_name }}</td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th colspan="7" class="text-end">Total</th>
                                    <th class="text-end">{{ reportData.total }}</th>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import ApiService from "../../Services/ApiService";
import PrintService from "../../Services/PrintService";
import ApiRoutes from "../../Services/ApiRoutes";

export default {
    data() {
        return {
            breadCrumb: ['Day Wise Deposit Report'],
            reportData: [],
            params: {
                start_date: '',
                end_date: '',
                project_id: '',
            },
            loading: false,
            exportLoading: false,
            projects:[],
        }
    },
    methods: {
        fetchProject: function() {
            ApiService.POST(ApiRoutes.Project + '/list', {limit: 100}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.projects = res.data.data;
                }
            });
        },
        downloadFile: function () {
            PrintService.print('/print/day-wise-deposit?project_id='+this.params.project_id + '&start_date=' +  this.params.start_date + '&end_date=' + this.params.end_date);
        },
        handleData() {
            this.loading = true;
            const body = {
                start_date: this.params.start_date,
                end_date: this.params.end_date,
                project_id: this.params.project_id
            }
            ApiService.POST(ApiRoutes.Report + '/day-wise-deposit-report', body, (res) => {
                this.loading = false;
                if (parseInt(res.status) === 200) {
                    this.reportData = res;
                } else {
                    ApiService.ErrorHandler(res.errors);
                }
            });
        }
    },
    created() {
        this.fetchProject();
    }
}
</script>

<style scoped>

</style>
